import mongoose from 'mongoose'
const schema  = mongoose.Schema({
    name:{
        type:String
    },
    fields:{
        type:Array
    },
    options:{
        type:mongoose.Schema.Types.Mixed
    }
})
export default mongoose.model("tabels",schema);